// extracted by mini-css-extract-plugin
module.exports = {"licenseSummary":"SectionPackageSeasonInfo_licenseSummary__nFwQ7","licenseTypeSelector":"SectionPackageSeasonInfo_licenseTypeSelector__38TXw"};